import type { TFunction } from "i18next";
import { ContractDatePresetDto } from "../../autogen/bff-api";

export const datePresetChoices = (t: TFunction) => {
  const labels: Record<ContractDatePresetDto, string> = {
    [ContractDatePresetDto.ThisYear]: t("This year"),
    [ContractDatePresetDto.Next90Days]: t("Next 90 days"),
    [ContractDatePresetDto.NextYear]: t("Next year"),
    [ContractDatePresetDto.Passed]: t("Passed"),
  };
  return Object.values(ContractDatePresetDto).map((value) => ({ value, label: labels[value] }));
};
